import {TextColorGradientRestDto, TextColorSolidRestDto} from "@/api/pharma-cms-content-page/models";
import {TextColorSolidRestDtoModel} from "@/models/api/TextColorSolidRestDtoModel";
import {DirectionEnum} from "@/api/enums/direction-enum";

export class TextColorGradientRestDtoModel implements TextColorGradientRestDto {
    direction_code: DirectionEnum;
    start: TextColorSolidRestDto;
    end: TextColorSolidRestDto;

    constructor(direction_code: DirectionEnum, start: TextColorSolidRestDto, end: TextColorSolidRestDto) {
        this.direction_code = direction_code;
        this.start = start;
        this.end = end;
    }

    static createWithDefaults(): TextColorGradientRestDtoModel {
        return new this(
            DirectionEnum.TO_RIGHT,
            TextColorSolidRestDtoModel.createWithDefaults(),
            TextColorSolidRestDtoModel.createWithDefaults(),
        );
    }

    static cloneFrom(source: TextColorGradientRestDto): TextColorGradientRestDtoModel {
        return new this(
            source.direction_code,
            TextColorSolidRestDtoModel.cloneFrom(source.start),
            TextColorSolidRestDtoModel.cloneFrom(source.end),
        );
    }
}
